<template>
  <v-card elevation="4">
    <v-card-title class="p-t-5">
      <v-icon size="24" color="primary">$settings</v-icon>
      <h5 class="ml-4 mb-0 font-weight-bold heading--text">
        {{ $t("heading.instance.modal.sharedAccess.privileges.title") }}
      </h5>
    </v-card-title>
    <v-card-text>
      <v-expansion-panels accordion class="elevation-0">
        <v-expansion-panel
          v-for="group in groups"
          :key="'expansion-panel.' + group.key"
        >
          <v-expansion-panel-header class="align-start">
            <Checkbox
              :indeterminate="groupIndeterminate(group.key)"
              :checked="groupChecked(group.key)"
              @change="toggleGroup(group.key)"
            />
            <div class="d-flex flex-column">
              <h6>
                {{ group.text }}
                <v-icon size="16" class="ml-1 mb-1 chevron"
                  >$chevrondown</v-icon
                >
              </h6>
              <span v-if="group.description" class="p-5 error--text">{{
                group.description
              }}</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div
              class="d-flex flex-row align-center"
              v-for="item in groupPrivileges(group.key)"
              :key="item.key"
            >
              <Checkbox
                v-if="customPrivilegesUser"
                :checked="
                  customPrivilegesUser.customPrivileges.includes(item.key)
                "
                @change="togglePrivilege(item.key)"
                :label="item.text"
                :class="item.color ? `checkbox--${item.color}-label` : ''"
              />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
    <v-card-actions class="d-flex flex-column pb-4 px-8 pt-8">
      <v-btn x-large elevation="0" color="primary" block @click="$emit('save')">
        {{ $t("button.save") }}
      </v-btn>
      <v-btn
        x-large
        elevation="0"
        class="mx-0 mt-2"
        color="gray"
        text
        block
        @click="$emit('cancel')"
      >
        <span class="p-1 font-weight-light gray--text text--darken-1">
          {{ $t("button.cancel") }}
        </span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import i18next from "i18next";
import { UserPrivilegesList } from "@/apis/HelperData.js";
import { getUserPrivilegesGroups } from "@/apis/HelperData.js";
import Checkbox from "../buttons/Checkbox.vue";

export default {
  components: { Checkbox },
  props: {
    instance: {
      type: Object,
      default() {
        return {
          id: 0,
          sharedAccess: [],
        };
      },
    },
    multiInstances: {
      type: Array,
      default: () => [],
    },
    customPrivilegesUser: {
      type: Object,
      default() {
        return {
          customPrivileges: [],
        };
      },
    },
  },
  computed: {
    privileges() {
      return UserPrivilegesList.map((item) => {
        return {
          key: item.key,
          group: item.group,
          text: this.$t(`privileges.list.${item.key}`),
        };
      });
    },
    groups() {
      return getUserPrivilegesGroups(i18next).filter((g) => {
        return this.groupPrivileges(g.key).length > 0;
      });
    },
    currentPrivileges() {
      if (this.instance.id) {
        return this.instance.privileges;
      }
      if (this.multiInstances.length === 0) {
        return this.privileges.map((item) => item.key);
      }
      let privs = [];
      for (let instance of this.multiInstances) {
        for (let privilege of instance.privileges) {
          if (!privs.includes(privilege)) {
            privs.push(privilege);
          }
        }
      }
      return privs;
    },
  },
  methods: {
    groupPrivileges(group) {
      return this.privileges.filter((p) => {
        return p.group == group && this.currentPrivileges.includes(p.key);
      });
    },
    groupChecked(group) {
      for (let priv of this.groupPrivileges(group)) {
        if (!this.customPrivilegesUser.customPrivileges.includes(priv.key)) {
          return false;
        }
      }
      return true;
    },
    groupIndeterminate(group) {
      if (this.groupChecked(group)) {
        return false;
      }
      for (let priv of this.groupPrivileges(group)) {
        if (this.customPrivilegesUser.customPrivileges.includes(priv.key)) {
          return true;
        }
      }
      return false;
    },
    toggleGroup(group) {
      let checked = this.groupChecked(group);
      for (let priv of this.groupPrivileges(group)) {
        checked
          ? this.uncheckPrivilege(priv.key)
          : this.checkPrivilege(priv.key);
      }
    },
    checkPrivilege(key) {
      if (!this.customPrivilegesUser.customPrivileges.includes(key)) {
        this.customPrivilegesUser.customPrivileges.push(key);
      }
    },
    uncheckPrivilege(key) {
      let index = this.customPrivilegesUser.customPrivileges.indexOf(key);
      if (index !== -1) {
        this.customPrivilegesUser.customPrivileges.splice(index, 1);
      }
    },
    togglePrivilege(key) {
      if (!this.customPrivilegesUser.customPrivileges.includes(key)) {
        this.checkPrivilege(key);
        return;
      }
      this.uncheckPrivilege(key);
    },
  },
};
</script>
<style src="./ShareInstanceModal.scss" lang="scss" scoped/>
